export const pkg = {
  name: 'isomorphic-git',
  version: '1.42.2',
  agent: 'git/isomorphic-git@1.42.2',
}
